import { JobPosting } from '../../services/job-search-service';

export default function insertJobAfter(jobs: JobPosting[], job: JobPosting, previous: number) {
    return (previous < 0 ? [job] : jobs.slice(0, previous + 1).concat(job))
        .concat(jobs.slice(previous + 1));
}
